import React from 'react';
import PropTypes from 'prop-types';

import thumbnailPic from '../../../../../static/images/images_placeholder.svg';
import useImageFallback from '../../../../hooks/useImageFallback';

const PortfolioGalleryImage = ({ src, alt }) => {
  const { src: displaySrc, onError } = useImageFallback(src, { placeholder: thumbnailPic });

  return (
    <img
      src={displaySrc}
      alt={alt || ''}
      onError={onError}
    />
  );
};

PortfolioGalleryImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string
};

export default PortfolioGalleryImage;
